import React, {Component} from 'react'
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes'

class CustomMultiSelectField extends Component {
  renderSelectedLabel = (placeholderButtonLabel, value) => {
    // this.props.scrollToBottom()
    if (!value) return placeholderButtonLabel
    if (!Array.isArray(value)) return value.label

    value = value.filter(item => item.value !== 'select_all')

    if (value.length === 0) return placeholderButtonLabel
    if (value.length > 3) {
      return (
        <div className="css-1v99tuv">
          {value.slice(0, 3).map(val => {
            return <span className="selected-data">{val.label}</span>
          })}
          <span className="selected-data-3">+{value.length - 3}</span>
        </div>
      )
    }
    return (
      <div className="css-1v99tuv">
        {value.map(val => {
          return <span className="selected-data">{val.label}</span>
        })}
      </div>
    )
  }

  checkSelectAll = currOption => {
    const {action, option} = currOption
    const isSelectAll = option.value === 'select_all' && action === 'select-option'
    const isDeselectAll = option.value === 'select_all' && action === 'deselect-option'
    const isNoting = option.value !== 'select_all' && action === 'deselect-option'
    return {isSelectAll, isDeselectAll, isNoting}
  }

  handleStateChange = (e, currOption) => {
    if (this.checkSelectAll(currOption).isSelectAll) {
      e = this.props.optionItems.filter(item => item.value !== 'select_all')
      this.props.handleChange(e)
    } else if (this.checkSelectAll(currOption).isDeselectAll) {
      this.props.handleChange([])
    } else {
      e = e.filter(item => item.value !== 'select_all')
      this.props.handleChange(e)
    }
  }

  render() {
    let selectesItems = this.props.value.map(item => {
      let label,
        value = ''
      if (item.template_id !== undefined) {
        label = item.template_name
        value = item.template_id
      } else if (item.user_id !== undefined) {
        label = item.user_name
        value = item.user_id
      } else if (item.field_id !== undefined) {
        label = item.field_name
        value = item.field_id
      }
      return {
        label: label,
        value: value,
      }
    })
    if (this.props.value.length === this.props.optionItems.length - 1) {
      selectesItems.unshift({label: 'Select All', value: 'select_all'})
    }

    return (
      <ReactMultiSelectCheckboxes
        menuIsOpen={this.props.menuIsOpen}
        value={selectesItems}
        placeholder="Search"
        tabSelectsValue={false}
        options={this.props.optionItems}
        className="styled_checkbox_for_multiselect"
        onChange={this.handleStateChange}
        placeholderButtonLabel="Select Fields"
        getDropdownButtonLabel={({placeholderButtonLabel, value}) =>
          this.renderSelectedLabel(placeholderButtonLabel, value)
        }
      />
    )
  }
}

export default CustomMultiSelectField
